// iOS Safari can drop its IndexedDB connection after a tab sits idle or
// backgrounded. Dexie may surface that either as the raw browser UnknownError
// or wrapped in DatabaseClosedError.inner, so inspect a few wrapper layers while
// still matching only the known "server lost" message.
export function isTransientIndexedDbDisconnectError(error: unknown): boolean {
  const parts: string[] = [];
  let current: unknown = error;

  for (let depth = 0; depth < 4 && current != null; depth++) {
    if (current instanceof Error) {
      parts.push(current.name, current.message);
      current =
        (current as Error & { cause?: unknown; inner?: unknown }).inner ??
        current.cause;
      continue;
    }

    if (typeof current === "object") {
      const maybeError = current as { name?: unknown; message?: unknown };
      if (typeof maybeError.name === "string") parts.push(maybeError.name);
      if (typeof maybeError.message === "string") {
        parts.push(maybeError.message);
      }
      break;
    }

    if (typeof current === "string") {
      parts.push(current);
    }
    break;
  }

  return parts
    .join(" ")
    .toLowerCase()
    .includes("connection to indexed database server lost");
}
